import React from 'react';

/**
 * NoInventory SVG Component
 * 
 * @param {string|number} width - Width of the SVG (default: 364)
 * @param {string|number} height - Height of the SVG (default: 280)
 * @param {string} className - Additional CSS class names
 * @param {object} style - Additional inline styles
 * @param {string} fill - Fill color for the illustration (optional)
 * @param {object} ...props - Additional props passed to the SVG element
 */
const NoInventorySvg = ({ 
  width = 300, 
  height = 250, 
  className = '',
  style = {},
  fill,
  ...props 
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 310 280" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...props}
    >
      <g opacity="0.62" filter="url(#filter0_f_5715_40253)">
        <path 
          d="M24.6391 128.446C44.7501 109.831 81.4403 94.6461 97.6271 47.6185C104.055 28.9435 133.532 19.4023 141.184 48.5002C146.939 70.3847 176.956 69.9382 195.042 68.7807C217.998 67.3116 239.483 107.872 221.53 131.092C203.577 154.311 215.158 182.132 217.998 190.169C221.53 200.163 242.072 228.673 217.998 247.19C170.615 283.636 133.934 253.742 97.6271 272.467C61.7215 290.984 54.0696 247.19 54.0696 241.018C54.0696 234.846 46.712 219.414 29.0537 208.98C-15.9161 182.41 7.37318 144.22 24.6391 128.446Z" 
          fill={fill || "#E6E6E6"}
        />
      </g>
      <path 
        opacity="0.37" 
        d="M175.892 106.345L174.633 78.377C174.633 78.377 174.633 64.5501 167.562 63.6346C149.302 61.2703 155.127 101.003 155.127 101.003L175.892 106.345Z" 
        fill="#666666"
      />
      <path 
        d="M166.768 251.528C131.799 274.494 76.5767 257.514 54.1338 247.443L146.318 91.8898C154.288 97.651 169.351 100.385 176.041 102.574C185.645 105.717 203.893 123 194.454 143.112C182.184 165.11 207.354 169.195 194.454 198.42C188.244 212.49 176.041 204.077 176.041 216.961C176.041 224.189 189.735 236.444 166.768 251.528Z" 
        fill="#DCD4CA"
      />
      
      {/* Filter definitions and other complex SVG elements */}
      <g filter="url(#filter1_g_5715_40253)">
        <path 
          d="M184.884 110.508C185.503 109.128 186.978 105.258 187.391 102.879C187.741 100.872 187.509 97.7166 187.329 96.4481C187.153 95.2478 186.935 94.421 186.788 93.9464C186.709 93.7125 186.623 93.4925 186.534 93.1096" 
          stroke="#995A00" 
          strokeWidth="4" 
          strokeLinecap="round"
        />
      </g>
      
      <g filter="url(#filter2_g_5715_40253)">
        <path 
          d="M221.516 83.2776C222.161 82.5444 222.982 81.4703 224.836 77.7067C225.372 76.5389 225.876 75.4035 226.197 74.6142C226.518 73.8248 226.641 73.4157 226.819 72.7859" 
          stroke="#995A00" 
          strokeWidth="4" 
          strokeLinecap="round"
        />
      </g>
      
      <g filter="url(#filter3_g_5715_40253)">
        <path 
          d="M215.229 121.435C215.498 121.495 218.432 122.445 222.141 123.508C223.908 124.014 227.076 125.051 229.531 126.073C233.747 127.83 236.386 129.961 238.173 131.377C239.823 132.684 240.463 133.636 241.21 134.306C241.408 134.444 241.629 134.562 241.853 134.708C242.077 134.853 242.298 135.022 242.782 135.35" 
          stroke="#995A00" 
          strokeWidth="4" 
          strokeLinecap="round"
        />
      </g>
      
      <g filter="url(#filter4_g_5715_40253)">
        <path 
          d="M202.026 70.2152C201.251 70.1287 199.336 70.1603 198.39 70.5154C197.076 71.0089 196.817 72.3645 196.609 73.5729C196.227 75.7965 197.335 77.3886 198.248 78.3837C198.943 79.1402 199.781 79.4475 200.43 79.5499C202.234 79.8345 203.317 78.9628 204.366 78.0695C205.602 77.0172 205.533 75.2844 205.588 72.8061C205.605 72.0389 205.235 71.5905 204.837 71.1746C204.404 70.8275 203.691 70.5134 202.832 70.2446C202.455 70.1305 202.197 70.0618 201.67 69.9388" 
          stroke="#995A00" 
          strokeWidth="4" 
          strokeLinecap="round"
        />
      </g>
      
      <g filter="url(#filter5_ig_5715_40253)">
        <path 
          d="M201.062 106.345L194.14 114.83H204.837L302.999 72.0921C302.999 72.0921 303.083 68.0666 302.055 65.8071C300.974 63.4318 297.65 60.7791 297.65 60.7791L201.062 106.345Z" 
          fill="#FFC066"
        />
        <path 
          d="M297.743 60.6619L297.744 60.6629L297.746 60.6639C297.748 60.6652 297.751 60.6671 297.754 60.6697C297.761 60.675 297.77 60.6831 297.782 60.6932C297.807 60.7135 297.844 60.7432 297.891 60.782C297.985 60.8599 298.119 60.9742 298.284 61.118C298.615 61.4054 299.067 61.8128 299.553 62.2957C300.521 63.2577 301.639 64.531 302.192 65.7449C302.717 66.8995 302.954 68.4926 303.062 69.784C303.116 70.4322 303.138 71.0096 303.146 71.4246C303.15 71.6321 303.151 71.7994 303.151 71.9149C303.15 71.9723 303.15 72.0172 303.15 72.0477C303.149 72.0628 303.149 72.0749 303.149 72.0828V72.0955L303.147 72.1912L303.059 72.2293L204.897 114.968L204.868 114.98H193.823L194.024 114.735L200.946 106.251L200.967 106.224L200.997 106.21L297.586 60.6434L297.67 60.6033L297.743 60.6619Z" 
          stroke="#FFA525" 
          strokeWidth="0.3"
        />
      </g>
      
      <path 
        d="M90.6296 243.044C77.101 243.044 48.4706 248.7 26.4471 248.7C26.8666 195.906 27.0134 87.4274 24.2447 75.863C21.4761 64.2987 28.7543 61.1981 32.7395 61.0933C74.8986 61.5123 159.652 61.0933 162.363 61.0933C166.139 61.0933 168.656 63.9216 168.656 63.9216C168.656 63.9216 157.015 64.2358 156.7 75.863V248.7C134.362 246.5 123.35 243.044 90.6296 243.044Z" 
        fill="#F2F2F2"
      />
      
      {/* Various paths for the shelf lines and details */}
      <path 
        d="M38.841 100.456C38.7813 100.456 38.5413 100.544 38.1423 100.781C37.7108 101.036 37.4714 102.115 37.2332 103.756C36.9696 105.572 36.9839 108.467 36.8263 111.958C36.6079 116.797 36.6106 118.78 36.705 119.723C36.82 120.872 39.3827 120.577 40.7746 120.74C42.9031 120.989 44.9125 121.094 45.9483 121.182C47.5595 121.32 49.3375 121.684 51.24 121.953C53.0099 122.202 53.8597 121.803 54.5859 121.419C55.4885 120.942 55.4043 119.63 55.5494 118.334C55.7941 116.148 56.4084 111.628 56.9966 108.689C57.2795 107.276 57.4173 106.28 57.4549 104.92C57.478 104.085 57.4133 103.376 57.2044 102.877C56.7961 101.901 55.6488 101.64 54.6275 101.306C52.0602 100.468 49.0366 100.494 47.7671 100.369C46.5918 100.253 44.7086 100.166 43.1131 100.075C42.4594 100.06 41.3828 100.06 40.7086 100.067C40.0345 100.075 39.7955 100.089 39.1418 100.149" 
        stroke="#995A00" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      
      <path 
        d="M37.5875 136.508C37.4093 136.753 36.8865 138.586 36.7048 146.881C36.6257 150.489 37.1742 154.27 37.8017 156.431C38.2455 157.959 41.3637 157.23 44.6833 157.309C46.3163 157.348 48.1001 157.494 50.3716 157.603C52.1764 157.689 54.4547 157.879 55.8555 157.496C56.9948 157.184 56.3926 154.815 56.5069 153.241C56.7719 149.591 56.9184 145.817 57.007 144.482C57.1181 142.809 57.148 140.767 57.2187 139.472C57.2363 139.149 57.2539 138.759 57.1829 138.451C57.112 138.144 56.9521 137.931 56.6921 137.759C55.564 137.014 53.649 137.138 52.2451 137.022C51.0624 136.924 49.5285 136.801 47.1645 136.729C45.4511 136.677 44.0935 136.461 42.4144 136.344C42.0432 136.317 41.7768 136.282 41.0534 136.255C40.3299 136.227 39.1576 136.21 37.9497 136.191" 
        stroke="#995A00" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      
      <path 
        d="M36.2697 174.044C36.2555 174.465 36.1336 175.668 36.0337 177.768C35.9588 179.344 35.9124 182.025 35.8564 184.843C35.82 186.67 35.6555 188.14 35.6191 190.652C35.6016 191.858 35.9773 192.669 36.5688 193.225C37.3822 193.989 38.9892 193.687 44.2137 193.774C48.3767 193.843 50.9357 194.092 51.7853 194.149C53.3405 194.253 54.6489 194.224 55.228 194.203C55.6825 194.186 55.9795 193.852 56.2191 193.502C56.9257 192.469 56.9754 190.138 57.1094 188.476C57.3086 186.007 57.4543 183.701 57.6035 182.171C57.7574 180.593 57.7308 178.777 57.8225 177.281C57.8934 176.124 57.8438 175.268 57.7154 174.924C57.431 174.163 55.9971 174.22 54.3604 174.075C50.2665 173.715 48.1802 174.003 46.7086 173.917C45.3754 173.839 42.0414 173.831 38.9417 173.728C38.4656 173.704 38.2807 173.69 37.9367 173.69C37.5926 173.689 37.095 173.703 36.4099 173.845" 
        stroke="#995A00" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      
      <path 
        d="M36.5523 209.896C36.6198 211.14 36.8484 213.948 37.0274 215.917C37.2334 218.183 37.0801 219.88 36.9307 222.45C36.8583 223.696 36.7212 225.143 36.5378 227.66C36.4987 228.196 36.4925 228.477 36.5551 228.698C36.7817 229.498 37.9036 229.569 39.3267 229.675C42.0731 229.88 46.6495 230.206 48.4119 230.441C49.6269 230.604 51.4173 230.714 52.9038 230.77C53.5324 230.794 54.1718 230.685 54.7435 230.449C55.1688 230.273 55.4596 229.954 55.696 229.472C55.9694 228.915 56.0243 228.283 56.0973 227.204C56.2411 225.081 56.2711 222.335 56.3263 220.068C56.3844 217.682 56.488 215.151 56.6038 212.818C56.6667 211.551 56.6126 210.487 56.391 210.165C55.902 209.454 54.67 209.496 48.6 209.425C43.6366 209.366 40.6225 209.477 40.1499 209.427C39.6488 209.391 38.6884 209.362 37.5403 209.375C37.089 209.403 36.9041 209.473 36.5844 209.629" 
        stroke="#995A00" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      
      {/* Shelf content areas */}
      <path 
        d="M59.0008 225.61L58.0569 227.182L55.54 227.81L39.809 226.239L40.4382 214.926L39.809 207.07L59.0008 207.384V225.61Z" 
        fill="#995A00" 
        fillOpacity="0.3"
      />
      
      <path 
        d="M57.9091 189.62L56.9653 191.191L54.4483 191.819L38.7173 190.248L39.3465 178.935L38.7173 171.079L57.9091 171.393V189.62Z" 
        fill="#995A00" 
        fillOpacity="0.3"
      />
      
      <path 
        d="M59.0005 153.795L58.0567 155.367L55.5397 155.995L39.8087 154.424C39.8087 154.424 39.1557 147.919 39.1795 143.739C39.2011 139.927 39.8087 133.998 39.8087 133.998L59.9444 135.255L59.0005 153.795Z" 
        fill="#995A00" 
        fillOpacity="0.3"
      />
      
      <path 
        d="M39.8925 118.005C39.8925 118.005 40.2355 100.895 40.7624 99.4608C41.2894 98.0261 41.0679 97.0253 44.2144 97.2473C47.361 97.4692 57.7116 96.5159 59.9516 98.7559C62.1916 100.996 61.2477 105.08 60.6235 109.438C59.9992 113.795 60.7062 119.142 60.0331 119.182C59.36 119.221 39.8925 118.005 39.8925 118.005Z" 
        fill="#995A00" 
        fillOpacity="0.3"
      />
      
      {/* Text lines on shelf */}
      <g opacity="0.74" filter="url(#filter6_g_5715_40253)">
        <path 
          d="M70.1173 139.34C74.2693 139.34 80.422 139.439 88.7418 139.467C97.0616 139.494 103.583 139.451 112.238 139.467C120.892 139.483 121.262 139.458 123.34 139.51C125.417 139.563 129.192 139.694 131.307 139.736C133.423 139.779 133.766 139.729 134.043 139.678" 
          stroke="#8C8C8C" 
          strokeWidth="5" 
          strokeLinecap="round"
        />
      </g>
      
      <g opacity="0.74" filter="url(#filter7_g_5715_40253)">
        <path 
          d="M69.55 148.453C70.7317 148.453 74.1447 148.282 80.5049 147.992C84.0608 147.873 88.2835 147.811 92.1526 147.827C96.0217 147.843 99.4094 147.938 102.9 148.036" 
          stroke="#8C8C8C" 
          strokeWidth="5" 
          strokeLinecap="round"
        />
      </g>
      
      <g opacity="0.74" filter="url(#filter8_g_5715_40253)">
        <path 
          d="M69.7107 175.389C69.858 175.389 70.0052 175.389 73.7177 175.455C93.9774 175.819 114.738 175.755 134.991 176.421" 
          stroke="#8C8C8C" 
          strokeWidth="5" 
          strokeLinecap="round"
        />
      </g>
      
      <g opacity="0.74" filter="url(#filter9_g_5715_40253)">
        <path 
          d="M70.2427 184.99C70.4389 184.965 70.6351 184.94 74.4487 184.927C78.2623 184.914 85.6873 184.914 91.8506 184.966C98.0139 185.018 102.69 185.122 107.509 185.23" 
          stroke="#8C8C8C" 
          strokeWidth="5" 
          strokeLinecap="round"
        />
      </g>
      
      <g opacity="0.74" filter="url(#filter10_g_5715_40253)">
        <path 
          d="M70.2057 212.487C70.2546 212.487 70.763 212.437 81.2935 212.494C91.3407 212.6 110.937 212.863 121.489 213.014C132.041 213.166 132.953 213.197 133.968 213.154" 
          stroke="#8C8C8C" 
          strokeWidth="5" 
          strokeLinecap="round"
        />
      </g>
      
      <g opacity="0.74" filter="url(#filter11_g_5715_40253)">
        <path 
          d="M70.6443 222.466C70.8409 222.441 71.0376 222.417 74.2716 222.296C77.5056 222.176 83.771 221.961 87.7866 221.838C93.3778 221.666 97.9568 221.72 102.799 221.779C106.515 221.632 108.015 221.5 109.427 221.439C110.037 221.411 110.43 221.386 110.835 221.36" 
          stroke="#8C8C8C" 
          strokeWidth="5" 
          strokeLinecap="round"
        />
      </g>
      
      {/* Additional detail paths */}
      <path 
        d="M68.6212 104.896C68.6951 104.896 68.7689 104.896 69.246 104.989C69.7232 105.081 70.6013 105.266 71.2808 105.388C71.9602 105.511 72.4143 105.567 73.4026 105.624" 
        stroke="#333333" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      
      <path 
        d="M77.7158 104.758C78.1049 104.832 78.494 104.905 78.932 104.986C79.37 105.067 79.8452 105.154 80.5274 105.227C81.2096 105.299 82.0843 105.355 83.4332 105.486" 
        stroke="#333333" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      
      <path 
        d="M88.964 105.472C88.9885 105.472 89.0129 105.472 89.2323 105.472C89.4517 105.472 89.8653 105.472 90.2978 105.488C90.7302 105.504 91.1691 105.535 92.5868 105.641" 
        stroke="#333333" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      
      <path 
        d="M98.9104 105.898C99.1556 105.898 99.4008 105.898 100.042 105.898C100.683 105.898 101.713 105.898 102.476 105.91C103.239 105.922 103.705 105.947 104.185 105.972" 
        stroke="#333333" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      
      <path 
        d="M108.782 105.661C108.831 105.661 109.782 105.661 111.416 105.689C112.124 105.717 112.587 105.773 113.12 105.814C113.653 105.854 114.242 105.879 114.849 105.904" 
        stroke="#333333" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      
      <path 
        d="M118.945 105.549C118.994 105.549 119.507 105.573 120.415 105.635C121.176 105.721 122.214 105.771 123.438 105.783C123.975 105.796 124.343 105.82 124.723 105.845" 
        stroke="#333333" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      
      <path 
        d="M68.1302 118.661C68.4455 118.587 68.7607 118.512 69.3881 118.474C70.0156 118.435 70.9457 118.435 71.6461 118.448C72.3466 118.46 72.7893 118.484 73.2454 118.509" 
        stroke="#333333" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      
      <path 
        d="M78.7914 118.292C79.2754 118.211 79.7594 118.13 80.6656 118.088C81.5718 118.046 82.8855 118.046 84.5356 117.97" 
        stroke="#333333" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      
      <path 
        d="M89.2544 117.798C89.8612 117.798 90.4681 117.798 91.1379 117.798C91.8077 117.798 92.5222 117.798 93.1717 117.81C93.8212 117.822 94.3841 117.847 94.9641 117.872" 
        stroke="#333333" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      
      <path 
        d="M99.152 118.044C99.5436 117.995 100.159 117.969 101.09 117.981C101.606 117.994 102.212 118.018 102.769 118.043C103.327 118.068 103.818 118.092 104.843 118.191" 
        stroke="#333333" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      
      <path 
        d="M108.743 117.863C109.085 117.863 109.967 117.838 111.253 117.837C111.833 117.861 112.267 117.935 112.773 117.997C113.279 118.059 113.843 118.108 114.571 118.306" 
        stroke="#333333" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      
      <path 
        d="M118.245 117.8C118.294 117.8 118.931 117.825 120.227 117.9C120.913 117.95 121.654 118.025 122.22 118.077C122.787 118.128 123.155 118.152 124.203 118.325" 
        stroke="#333333" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      
      <path 
        d="M127.861 118.474C127.885 118.474 127.91 118.474 128.458 118.501C129.006 118.529 130.078 118.585 130.826 118.638C131.574 118.691 131.966 118.74 132.89 118.864" 
        stroke="#333333" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      
      <path 
        d="M138.955 119.623C139.447 119.623 140.02 119.721 140.675 119.881C141.01 119.944 141.35 119.968 141.695 120.005C142.04 120.043 142.379 120.091 143.398 120.216" 
        stroke="#333333" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      
      <path 
        d="M148.237 120.778C148.975 121.024 150.539 121.271 151.922 121.522C152.254 121.588 152.594 121.637 152.977 121.674C153.361 121.712 153.778 121.736 154.207 121.761" 
        stroke="#333333" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      
      <path 
        d="M158.789 120.637C158.985 120.488 159.429 120.088 160.071 119.449C160.615 118.835 161.063 118.254 161.433 117.665C161.607 117.35 161.754 117.002 162.054 115.814" 
        stroke="#333333" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      
      <path 
        d="M162.876 112.031C162.801 111.357 162.301 110.052 161.571 108.896C161.369 108.617 161.145 108.369 160.88 108.116C160.616 107.864 160.317 107.615 159.934 107.359" 
        stroke="#333333" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      
      <path 
        d="M156.189 105.057C156.14 105.057 155.74 104.983 154.776 104.857C154.185 104.806 153.389 104.781 152.804 104.817C152.219 104.854 151.871 104.951 150.606 105.348" 
        stroke="#333333" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      
      <path 
        d="M147.283 108.021C147.133 108.069 146.733 108.315 146.118 108.819C145.578 109.447 145.047 110.215 144.533 111.016C144.292 111.402 144.093 111.745 143.737 112.468" 
        stroke="#333333" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      
      <path 
        d="M144.326 115.908C144.276 116.324 144.224 117.903 144.548 119.38C144.651 119.715 144.755 120.03 144.907 120.425C145.059 120.82 145.255 121.285 145.753 122.06" 
        stroke="#333333" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      
      <path 
        d="M148.322 125.426C148.371 125.524 148.882 125.899 149.778 126.44C150.506 126.754 151.128 127.051 151.746 127.408C152.069 127.57 152.413 127.692 153.509 128.114" 
        stroke="#333333" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      
      <path 
        d="M157.68 128.97C157.778 128.97 158.169 129.068 159.066 129.229C159.622 129.291 160.384 129.316 160.985 129.34C161.585 129.365 162.002 129.39 163.173 129.264" 
        stroke="#333333" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      
      <path 
        d="M166.932 128.624C166.981 128.624 167.449 128.599 168.292 128.537C169.037 128.449 169.735 128.348 170.451 128.223C170.824 128.148 171.216 128.048 172.14 127.72" 
        stroke="#333333" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      
      <path 
        d="M176.843 124.416C177.409 124.141 178.845 123.339 179.998 122.385C180.26 122.132 180.48 121.884 180.692 121.619C180.903 121.354 181.099 121.08 181.523 120.497" 
        stroke="#333333" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      
      <path 
        d="M193.724 115.06C193.726 115.053 193.752 115.023 193.86 114.908C194.086 114.668 194.252 114.499 194.292 114.473C194.4 114.402 194.519 114.26 194.677 114.102C194.75 114.029 194.862 113.921 194.965 113.817C194.982 113.8 194.995 113.79 195.006 113.791C195.066 113.799 195.144 114.064 195.231 114.257C195.335 114.486 195.346 114.559 195.386 114.693C195.414 114.788 195.441 114.862 195.456 114.928C195.464 114.958 195.276 114.948 194.993 114.942C194.843 114.939 194.679 114.929 194.541 114.93C194.155 114.933 194.052 114.982 193.982 115.004C193.92 115.024 193.868 115.032 193.846 115.03C193.824 115.028 193.985 114.946 194.204 114.849C194.495 114.721 194.562 114.66 194.744 114.577C194.788 114.556 194.815 114.54 194.836 114.528C194.857 114.516 194.871 114.509 194.888 114.499" 
        stroke="black" 
        strokeLinecap="round"
      />
      
      {/* All the filter definitions */}
      <defs>
        <filter id="filter0_f_5715_40253" x="0" y="27" width="232.527" height="253" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feGaussianBlur stdDeviation="1.5" result="effect1_foregroundBlur_5715_40253"/>
        </filter>
        
        <filter id="filter1_g_5715_40253" x="182.384" y="90.6092" width="7.68872" height="22.399" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feTurbulence type="fractalNoise" baseFrequency="5 5" numOctaves="3" seed="4756" />
          <feDisplacementMap in="shape" scale="1" xChannelSelector="R" yChannelSelector="G" result="displacedImage" width="100%" height="100%" />
          <feMerge result="effect1_texture_5715_40253">
            <feMergeNode in="displacedImage"/>
          </feMerge>
        </filter>
        
        <filter id="filter2_g_5715_40253" x="219.016" y="70.2855" width="10.3038" height="15.4921" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feTurbulence type="fractalNoise" baseFrequency="5 5" numOctaves="3" seed="4756" />
          <feDisplacementMap in="shape" scale="1" xChannelSelector="R" yChannelSelector="G" result="displacedImage" width="100%" height="100%" />
          <feMerge result="effect1_texture_5715_40253">
            <feMergeNode in="displacedImage"/>
          </feMerge>
        </filter>
        
        <filter id="filter3_g_5715_40253" x="212.728" y="118.934" width="32.5538" height="18.9159" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feTurbulence type="fractalNoise" baseFrequency="5 5" numOctaves="3" seed="4756" />
          <feDisplacementMap in="shape" scale="1" xChannelSelector="R" yChannelSelector="G" result="displacedImage" width="100%" height="100%" />
          <feMerge result="effect1_texture_5715_40253">
            <feMergeNode in="displacedImage"/>
          </feMerge>
        </filter>
        
        <filter id="filter4_g_5715_40253" x="194.031" y="67.4384" width="14.0577" height="14.6666" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feTurbulence type="fractalNoise" baseFrequency="5 5" numOctaves="3" seed="4756" />
          <feDisplacementMap in="shape" scale="1" xChannelSelector="R" yChannelSelector="G" result="displacedImage" width="100%" height="100%" />
          <feMerge result="effect1_texture_5715_40253">
            <feMergeNode in="displacedImage"/>
          </feMerge>
        </filter>
        
        <filter id="filter5_ig_5715_40253" x="133.508" y="0.42804" width="229.792" height="174.702" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="-6"/>
          <feGaussianBlur stdDeviation="3.5"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0.925781 0 0 0 0 0.593191 0 0 0 0 0.120174 0 0 0 1 0"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_5715_40253"/>
          <feTurbulence type="fractalNoise" baseFrequency="7.1428570747375488 7.1428570747375488" numOctaves="3" seed="1053" result="displacementX" />
          <feTurbulence type="fractalNoise" baseFrequency="7.1428570747375488 7.1428570747375488" numOctaves="3" seed="1054" result="displacementY" />
          <feColorMatrix in="displacementX" type="matrix" values="0 0 0 1 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0 1" result="displacementXRed" />
          <feColorMatrix in="displacementY" type="matrix" values="0 0 0 0 0  0 0 0 1 0  0 0 0 0 0  0 0 0 0 1" />
          <feComposite in="displacementXRed" operator="arithmetic" k1="0" k2="1" k3="1" k4="0"/>
          <feDisplacementMap in="effect1_innerShadow_5715_40253" scale="120" xChannelSelector="R" yChannelSelector="G" width="100%" height="100%" />
          <feColorMatrix type="matrix" values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 1 0" />
          <feComponentTransfer result="sourceDisplacedAlpha">
            <feFuncA type="gamma" exponent="0.2" />
          </feComponentTransfer>
          <feColorMatrix in="effect1_innerShadow_5715_40253" type="matrix" values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 1 0" />
          <feComponentTransfer result="inputSourceAlpha">
            <feFuncA type="gamma" exponent="0.2" />
          </feComponentTransfer>
          <feComposite in="sourceDisplacedAlpha" operator="arithmetic" k1="1" k2="0" k3="0" k4="0" result="displacementAlphasMultiplied"/>
          <feComposite in="displacementAlphasMultiplied"  operator="arithmetic" k1="0" k2="0" k3="-0.5" k4="0.5" result="centeringAdjustment"/>
          <feComposite in="displacementX" in2="displacementAlphasMultiplied" operator="arithmetic" k1="1" k2="0" k3="0" k4="0" />
          <feComposite in="centeringAdjustment" operator="arithmetic" k1="0" k2="1" k3="1" k4="0" />
          <feColorMatrix  type="matrix" values="0 0 0 1 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0 1" result="displacementXFinal" />
          <feComposite in="displacementY" in2="displacementAlphasMultiplied" operator="arithmetic" k1="1" k2="0" k3="0" k4="0" />
          <feComposite in="centeringAdjustment" operator="arithmetic" k1="0" k2="1" k3="1" k4="0" />
          <feColorMatrix  type="matrix" values="0 0 0 0 0  0 0 0 1 0  0 0 0 0 0  0 0 0 0 1" result="displacementYFinal" />
          <feComposite in="displacementXFinal" in2="displacementYFinal" operator="arithmetic" k1="0" k2="1" k3="1" k4="0" />
          <feComposite in2="displacementAlphasMultiplied" operator="in" result="displacementMap" />
          <feFlood floodColor="rgb(127, 127, 127)" floodOpacity="1"/>
          <feComposite in2="displacementAlphasMultiplied" operator="out" />
          <feComposite in2="displacementMap" operator="over" result="displacementMapWithBg"/>
          <feDisplacementMap in="effect1_innerShadow_5715_40253" scale="120" xChannelSelector="R" yChannelSelector="G" width="100%" height="100%" result="displacedImage" />
          <feColorMatrix in="effect1_innerShadow_5715_40253" type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 127 0" result="imageOpaque" />
          <feDisplacementMap in="imageOpaque" in2="displacementMapWithBg" scale="120" xChannelSelector="R" yChannelSelector="G" width="100%" height="100%" result="displacedImageOpaque" />
          <feColorMatrix in="displacedImage" type="matrix" values="0 0 0 1 0  0 0 0 0 0  0 0 0 0 0  0 0 0 127 0" result="displacedImageRed" />
          <feColorMatrix in="effect1_innerShadow_5715_40253" type="matrix" values="0 0 0 1 0  0 0 0 0 0  0 0 0 0 0  0 0 0 127 0" />
          <feComposite in="displacedImageRed"  operator="atop" result="transparencyRedMap"/>
          <feColorMatrix in="transparencyRedMap" type="matrix" values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  1 0 0 0 0" result="transparencyAlphaMap" />
          <feComposite in="displacedImageOpaque" in2="imageOpaque" operator="over" />
          <feComposite in2="transparencyAlphaMap" operator="in" result="effect2_texture_5715_40253"/>
        </filter>
        
        <filter id="filter6_g_5715_40253" x="66.6273" y="135.85" width="70.9065" height="7.39205" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feTurbulence type="fractalNoise" baseFrequency="0.06915629655122757 0.06915629655122757" numOctaves="3" seed="6140" />
          <feDisplacementMap in="shape" scale="1.9800000190734863" xChannelSelector="R" yChannelSelector="G" result="displacedImage" width="100%" height="100%" />
          <feMerge result="effect1_texture_5715_40253">
            <feMergeNode in="displacedImage"/>
          </feMerge>
        </filter>
        
        <filter id="filter7_g_5715_40253" x="66.06" y="144.335" width="40.3297" height="7.60851" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feTurbulence type="fractalNoise" baseFrequency="0.06915629655122757 0.06915629655122757" numOctaves="3" seed="6140" />
          <feDisplacementMap in="shape" scale="1.9800000190734863" xChannelSelector="R" yChannelSelector="G" result="displacedImage" width="100%" height="100%" />
          <feMerge result="effect1_texture_5715_40253">
            <feMergeNode in="displacedImage"/>
          </feMerge>
        </filter>
        
        <filter id="filter8_g_5715_40253" x="66.2207" y="171.899" width="72.2604" height="8.01253" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feTurbulence type="fractalNoise" baseFrequency="0.06915629655122757 0.06915629655122757" numOctaves="3" seed="6140" />
          <feDisplacementMap in="shape" scale="1.9800000190734863" xChannelSelector="R" yChannelSelector="G" result="displacedImage" width="100%" height="100%" />
          <feMerge result="effect1_texture_5715_40253">
            <feMergeNode in="displacedImage"/>
          </feMerge>
        </filter>
        
        <filter id="filter9_g_5715_40253" x="66.7524" y="181.43" width="44.2464" height="7.29024" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feTurbulence type="fractalNoise" baseFrequency="0.06915629655122757 0.06915629655122757" numOctaves="3" seed="6140" />
          <feDisplacementMap in="shape" scale="1.9800000190734863" xChannelSelector="R" yChannelSelector="G" result="displacedImage" width="100%" height="100%" />
          <feMerge result="effect1_texture_5715_40253">
            <feMergeNode in="displacedImage"/>
          </feMerge>
        </filter>
        
        <filter id="filter10_g_5715_40253" x="66.7157" y="208.977" width="70.7423" height="7.68447" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feTurbulence type="fractalNoise" baseFrequency="0.06915629655122757 0.06915629655122757" numOctaves="3" seed="6140" />
          <feDisplacementMap in="shape" scale="1.9800000190734863" xChannelSelector="R" yChannelSelector="G" result="displacedImage" width="100%" height="100%" />
          <feMerge result="effect1_texture_5715_40253">
            <feMergeNode in="displacedImage"/>
          </feMerge>
        </filter>
        
        <filter id="filter11_g_5715_40253" x="67.154" y="217.87" width="47.171" height="8.08648" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feTurbulence type="fractalNoise" baseFrequency="0.06915629655122757 0.06915629655122757" numOctaves="3" seed="6140" />
          <feDisplacementMap in="shape" scale="1.9800000190734863" xChannelSelector="R" yChannelSelector="G" result="displacedImage" width="100%" height="100%" />
          <feMerge result="effect1_texture_5715_40253">
            <feMergeNode in="displacedImage"/>
          </feMerge>
        </filter>
      </defs>
    </svg>
  );
};

export default NoInventorySvg;